import type { Transition, Variants } from 'framer-motion';

export enum InfoActionVariant {
    Initial = 'initial',
    Show = 'show',
}

export const infoActionVariants: Variants = {
    [InfoActionVariant.Initial]: {
        opacity: 0,
    },
    [InfoActionVariant.Show]: {
        opacity: 1,
    },
};

export const infoActionTransition: Transition = {
    type: 'easeInOut',
    // Framer Motion likely clones <AnimatePresence /> elements for exit animations,
    // and therefore we do not get a fade out when the parent <InlineInput />
    // is closed while <InfoAction /> is still visible.
    duration: 0.2,
};
